<template>
  <div>
    <div class="home_topbar">
      <div class="home_topbar_wrap">
        <a :href="host.sgsonlineUrl" title="SGS中国丨在线商城">SGS通标丨在线商城</a>
        <div class="home_topbar_menu">
          <span>您好，
            <template v-if='userInfo.userNick'>
              <a title="昵称" :href='host.memberUrl + "/member/center"'>{{ userInfo.userNick }}</a>
              <template v-if='userInfo.activity.includes("PROMOTION001")'>
                <a :href='host.memberUrl + "member/center#member-coupon"'>
                  <img v-if='userInfo.levelId === 1' src="./../../assets/images/portal/pro_b.png" alt="">
                  <img v-else src="./../../assets/images/portal/pro_a.png" alt="">
                </a>
              </template>
              <a v-else :href='host.memberUrl + "/promember?promosource=header"' class="mainColor"
                style="margin-left: 5px;">免费升级会员</a>
              <em @click="logout">退出</em>
            </template>
            <a v-else title="登录" :href='host.memberUrl + "/login"' class="mainColor">请登录/注册</a>
          </span>
          <span class="home_topbar_menu-border">
            <a :href='host.memberUrl + "/member/center"'>个人中心</a>
          </span>
          <span>
            <a :href='host.memberUrl + "/quote/list"'>我的咨询</a></span>
          <span class="myorder">
            <a :href='userInfo.lv3OrderNum ? host.storeUrl + "/myorder.html" : host.memberUrl + "/order/list"'>我的订单</a>
          </span>
          <span class="home_topbar_menu-border">
            <a :href='host.storeUrl + "/cart.html"' class="home_topbar_menu-car">
              购物车（{{ carNum }}）
            </a>
          </span>
          <span style="cursor:pointer" @click="handleHotline">
            咨询热线<em style="font-weight: bold; font-style: normal; font-size: 14px;" class="mainColor">400-998-1165</em>
          </span>
          <span><a :href="host.sgsonlineUrl + '/ticket/en'" target="_blank">CONTACT US</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mergeTopbar, logout } from 'src/request/portal'
import { host } from 'src/config'

export default {
  name: 'PortalTopbar',
  props: {
    env: {
      type: String,
      default: 'local',
    },
  },
  data() {
    return {
      host: host(this.env),
      userInfo: {},
      carNum: Cookies.get('CARTNUMBER') || 0,
    }
  },
  methods: {
    logout() {
      this.$confirm('请确认退出登录？', '', {
        callback: (res) => {
          debugger
          if (res === 'confirm') {
            logout({}, this.host.nodeUrl).then((res) => {
              if (res) {
                this.userInfo = {}
                Cookies.remove('SSO_TOKEN', { domain: '.sgsonline.com.cn' })
                Cookies.remove('CARTNUMBER', { domain: '.sgsonline.com.cn' })
                window.location.reload()
              }
            })
          }
        },
      })
    },
    handleHotline() {
      this.$alert(
        `<div class="tip_info" style="color: #000000;font-size: 14px;padding: 0 22px;line-height: 24px;margin-top: 18px;margin-bottom: 0px">
            <p>SGS在线商城客服热线：<br><a style="color: #ff5702" href="${this.host.sgsonlineUrl}/hotline" target="_blank" id="phoneNum">400-998-1165</a>
            </p>
            <span>工作时间：</span>
            <p>周一~周六 9:00至17:00（节假日除外）<br>如遇忙线，请给我们
                <a href="${this.host.sgsonlineUrl}/baojia" style="color:#ca4300" target="_blank">留言</a>，工作日最快2小时回复</p>
        </div>`,
        '客服电话',
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
        }
      )
    },
  },
  mounted() {
    mergeTopbar({}, this.host.nodeUrl).then((res) => {
      if (res) this.userInfo = res.data || {}
    })
  },
}
</script>


<style lang='scss'>
@import './../../assets/style/mixin.scss';

.home_topbar {
  height: 35px;
  line-height: 35px;
  background: #e3e3e3;

  .home_topbar_wrap {
    width: 1226px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;

    a {
      color: #626262;
      cursor: pointer;

      &:hover {
        color: $mainColor;
      }
    }

    .mainColor {
      color: $mainColor;
    }
  }

  .home_topbar_menu {
    * {
      color: #626262;
      height: 13px;
      line-height: 13px;
    }

    span {
      padding-left: 15px;

      &.myorder {
        cursor: pointer;

        &:hover {
          color: $mainColor;
        }
      }
    }

    .pro_icon {
      width: 40px;
      height: 17px;
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
    }

    .home_topbar_menu-border {
      border-left: 1px solid #626262;
      margin-left: 15px;
    }

    .home_topbar_menu-car {
      background: url('./../../assets/images/portal/car.png') no-repeat left center;
      padding-left: 15px;
    }
  }
}
</style>